import type { IShowcaseTriggerProps } from './types';
import { useShowcase } from './useShowcase';

/**
 * Simple declarative component to trigger a showcase.
 * Useful when a showcase should start when a component is rendered.
 *
 * The showcase will only be shown if it hasn't been seen before.
 *
 * @see useShowcase for the hook version
 *
 * @example
 * ```tsx
 * // In a component that renders when user should see the showcase:
 * function NavigationSidebar() {
 *   return (
 *     <>
 *       <ShowcaseTrigger showcase="v2.55.0 Updated navigation sidebar" />
 *       {... rest of component}
 *     </>
 *   );
 * }
 * ```
 */
export function ShowcaseTrigger({ showcase, delay }: IShowcaseTriggerProps) {
  useShowcase(showcase, true, { delay });
  return null;
}
